import type { Delivery, DeliveryStatus } from "@types_def/models/delivery.types";

import { sendRequest } from "../clients/axios";

type ConfirmDeliveryBySMSInput = {
  status: DeliveryStatus;
};

class DeliveryConfirmationError extends Error {
  public readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "DeliveryConfirmationError";
    this.status = status;
  }
}

export async function updateBySMS(token: string, status: DeliveryStatus) {
  return sendRequest<ConfirmDeliveryBySMSInput, Delivery>(
    "post",
    "delivery/confirm-delivery-by-sms",
    { status },
    {
      headers: {
        token,
      },
    }
  ).then((response) => {
    if (response.status === 200 || response.status === 201) {
      return response.data;
    }
    throw new DeliveryConfirmationError(
      `Failed to confirm delivery by SMS. Unexpected status code: ${response.status}`,
      response.status
    );
  });
}
